__turbopack_context__.v({
  "className": "inter_42f703e8-module__48uroG__className",
  "variable": "inter_42f703e8-module__48uroG__variable",
});
